import { format, formatDistanceToNow, fromUnixTime, isSameDay, isSameMonth, isSameWeek } from 'date-fns';
import eoLocale from 'date-fns/locale/fr';
import { capitalize } from 'lodash';
/**
 * Fonction permettant de convertir une date dans le format que l'on souhaite
 *
 * @param date La date sous forme de timestamp unix
 * @param display Type de date que l'on souhaite recevoir (date, fulldate, relative, since, hour)
 * @return La date sous forme de string
 * @see https://date-fns.org/v2.29.3/docs/format
 */
export function useFormatDate({ date, display }) {
    if (!date) {
        return '';
    }
    const myDate = fromUnixTime(date);
    switch (display) {
        // 01/03/2021
        case 'date': {
            return format(myDate, 'dd/MM/yyyy', {
                locale: eoLocale,
            });
        }
        // 01/03/2021 à 18h00
        case 'datetime': {
            return format(myDate, "dd/MM/yy à HH'h'mm", {
                locale: eoLocale,
            });
        }
        // Mercredi 1 mars à 18h00
        case 'fulldate': {
            return format(myDate, "EEEE d LLLL à HH'h'mm", {
                locale: eoLocale,
            });
        }
        // Mercredi 1 mars
        case 'dateYear': {
            return capitalize(format(myDate, 'EEEE d LLLL yyyy', {
                locale: eoLocale,
            }));
        }
        // Il y a 2 jours
        case 'relative': {
            const myDateDistribution = formatDistanceToNow(myDate, {
                locale: eoLocale,
            });
            return `il y a ${myDateDistribution}`;
        }
        // Depuis 2 jours
        case 'since': {
            const myDateSince = formatDistanceToNow(myDate, {
                locale: eoLocale,
            });
            return `depuis ${myDateSince}`;
        }
        // 18h00
        case 'time': {
            return format(myDate, "HH'h'mm", {
                locale: eoLocale,
            });
        }
        // 18:00 ou Mardi ou Mardi décembre ou 13/08/2003
        default: {
            let returnDate = '';
            if (isSameDay(myDate, new Date())) {
                returnDate = format(myDate, "HH':'mm", {
                    locale: eoLocale,
                });
            }
            else if (isSameWeek(myDate, new Date())) {
                returnDate = format(myDate, 'EEEE', {
                    locale: eoLocale,
                });
            }
            else if (isSameMonth(myDate, new Date())) {
                returnDate = `il y a ${formatDistanceToNow(myDate, {
                    locale: eoLocale,
                })}`;
            }
            else {
                returnDate = format(myDate, 'dd/MM/yy', {
                    locale: eoLocale,
                });
            }
            return returnDate;
        }
    }
}
//# sourceMappingURL=data:application/json;base64,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